export const formatDouble = (value: number, digit = 0) => {
  if (value) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    });
  }

  return '0.00';
};

export const formatDoubleIfHasDecimal = (value: number, digit = 0) => {
  if (value) {
    const formatted = value.toLocaleString(undefined, {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    });

    const regexStr = `.${'0'.repeat(digit)}$`;
    return formatted.replace(new RegExp(regexStr), '');
  }

  return '0';
};
